import { render, staticRenderFns } from "./webhook.vue?vue&type=template&id=27850f2e&scoped=true&"
import script from "./webhook.vue?vue&type=script&lang=js&"
export * from "./webhook.vue?vue&type=script&lang=js&"
import style0 from "./webhook.vue?vue&type=style&index=0&id=27850f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27850f2e",
  null
  
)

export default component.exports